import { UserProfileType } from '../../types/user';

/**
 * returns percentage of completion for user profile
 */
export const profileCompletionCalculator = (prop: UserProfileType) => {
  // COMPUTATION
  // PROFILE IMAGE 10
  // PRIMARY INFORMATION 10
  // SECONDARY INFORMATION 10
  // STORE BANNER + STORE LOGO 10
  // STORE INFORMATION 10
  // OFFICIAL DOCS x
  let total: number = prop?.verification_progress?.completion_ratio
    ? prop?.verification_progress?.completion_ratio / 2
    : 0;
  if (prop?.extended_user?.meta_data?.primary_information) {
    let profile = prop?.extended_user?.meta_data.primary_information;
    if (profile?.middle_name) total += 0.042;
    if (profile?.date_of_birth) total += 0.042;
    if (profile?.secondary_email) total += 0.042;
    if (profile?.secondary_phone) total += 0.042;
    if (profile?.additional_info) total += 0.042;
  }
  if (prop?.extended_user?.meta_data?.secondary_information) {
    let profile = prop?.extended_user?.meta_data?.secondary_information;
    if (profile?.user_name) total += 0.042;
    if (profile?.website) total += 0.042;
    if (profile?.short_bio) total += 0.042;
  }
  // if (prop?.extended_user?.address && prop?.extended_user?.address?.length > 0)
  //   if (prop?.extended_user.profile_image) total += 0.042;
  if (prop?.stores?.length > 0) {
    if (prop?.stores[0]?.store_name) total += 0.062;
    if (prop?.stores[0]?.store_address) total += 0.02;
    if (prop?.stores[0]?.store_phone) total += 0.02;
    if (prop?.stores[0]?.store_email) total += 0.02;

    if (prop?.stores[0]?.banner_image) total += 0.021;
    if (prop?.stores[0]?.logo) total += 0.021;
  }
  return Math.min(Math.round(total * 100), 100);
};
